//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_COMPLIANT_ITEMS = "obtenerCompliantItems";
export const OBTENER_COMPLIANT_ITEM = "obtenerCompliantItem";
export const ACTUALIZAR_COMPLIANT_ITEM = "actualizarCompliantItem";
// mutation types
export const SET_COMPLIANT_ITEMS = "setCompliantItems";
export const SET_COMPLIANT_ITEM = "setCompliantItem";

const state = {
    compliantItems: [],
    compliantItem:[],
}

const getters = {
    obtenerCompliantItems(state) {
      return state.compliantItems;
    },
}

const actions = {

    /**
     * Obtener el listado de solicitudes del compliant por estado (desde 2)
     * @param {*} context 
     * @param {*} estadoId 
     * @returns 
     */
    async [OBTENER_COMPLIANT_ITEMS](context, estadoId) {

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=api/Compliant/GetSolicitudesCompliantByEstado/${estadoId}`, '')
                .then(({ data }) => {
                    context.commit(SET_COMPLIANT_ITEMS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_COMPLIANT_ITEM](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_COMPLIANT_ITEM, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    
    async [ACTUALIZAR_COMPLIANT_ITEM](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Empresas/UpdateEmpresas/`, datos.datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_COMPLIANT_ITEM, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

  }

const mutations = {
    [SET_COMPLIANT_ITEMS](state, data) {
        state.compliantItems = data;
    },

    [SET_COMPLIANT_ITEM](state, data) {
        state.compliantItem = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}